import React from 'react'

export const WorkflowConfig = {
  routes: [
    {
      path: "/workflow/create",
      component: React.lazy(() => import('./WorkflowCreateScreen'))
    },
    {
      path: "/workflow/edit/:workflowId",
      component: React.lazy(() => import('./WorkflowCreateScreen'))
    },
    {
      path: "/workflow/list",
      component: React.lazy(() => import('./WorkflowListScreen'))
    }
  ]
};

